const ProductAddedToCartModalStyle = {
  MODAL: 'MODAL',
  POPOVER: 'POPOVER'
};

export default ProductAddedToCartModalStyle;
